import { Accordion } from 'react-bootstrap';

import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import { AccordionBody } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Overview/AccordionBody';
import { AccordionHeader } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Overview/AccordionHeader';
import * as State from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/State';
import { ID } from 'types/Recipe/Detail/ErpNew/ErpRecipe';

type IProps = RecipeErpViewComponentProps;

const ErpRecipeAccordion = (props: IProps) => {
	const listItems = State.getErpRecipesBySearchTerm(props.state).filter(
		(e) => e.id !== ID.TEMPLATE
	);
	if (!listItems.length) return <></>;
	return (
		<Accordion>
			{listItems.map((erpRecipe, i) => {
				return (
					<Accordion.Item eventKey={String(i)} key={i + 'item'}>
						<Accordion.Header>
							<AccordionHeader {...props} erpRecipe={erpRecipe} />
						</Accordion.Header>
						<Accordion.Body style={{ border: '5px solid #e0ebf5', borderTop: '0' }}>
							<AccordionBody {...props} erpRecipe={erpRecipe} />
						</Accordion.Body>
					</Accordion.Item>
				);
			})}
		</Accordion>
	);
};

export default ErpRecipeAccordion;
